import React, { useEffect, useState } from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials as mockTestimonials } from '../../mock/mockData';
import { fetchTestimonials } from '../../lib/api';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState(mockTestimonials);
  useEffect(() => {
    fetchTestimonials().then((data) => data?.length && setTestimonials(data)).catch(() => {});
  }, []);
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-6 mb-12">
          <div>
            <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Témoignages</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 tracking-tight max-w-2xl">Ce que disent nos professionnels de santé</h2>
          </div>
          <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl px-5 py-3">
            <div className="flex items-center gap-1 text-amber-500">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
            </div>
            <div>
              <p className="text-sm font-bold text-slate-900">4.8/5 sur Google</p>
              <p className="text-xs text-slate-500">Basé sur 142 avis vérifiés</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 9).map((t, i) => (
            <div key={i} className="group bg-gradient-to-br from-white to-slate-50/50 border border-slate-200 rounded-2xl p-6 hover:border-teal-300 hover:shadow-lg transition-all duration-300 relative">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-teal-100 group-hover:text-teal-200 transition-colors" />
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-11 h-11 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-sm shrink-0`}>
                  {t.initials}
                </div>
                <div>
                  <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.time}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 text-amber-500 mb-3">
                {[...Array(t.rating)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-current" />)}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
